module.exports = "/_next/static/images/X-b161893c080bbf6909508ea1537b04c3.png";